// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__dHjNq","spin":"Loader_spin__vgpBG","loadsuccess":"Loader_loadsuccess__5NigX","loaderror":"Loader_loaderror__snUZe","mini":"Loader_mini__+TDD5"};